import 'styles/ToggleYears.css';

export default class ToggleYears {
    constructor() {
        this._map = window.cartovista.getMap("map1");
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
        this._firstBtn = $("#BtnFirst");
        this._laterBtn = $("#BtnLater");
        this._firstBtn.click(this._onFirstBtnClicked.bind(this));
        this._laterBtn.click(this._onLaterBtnClicked.bind(this));
        this._chartViewController = window.cartovista.getUIController(this._map).findInstance("chartView");
    }

    _onFirstBtnClicked(evt) {
        console.log("_onFirstBtnClicked")
        if (!this._firstBtn.hasClass("active")) {
            this._toggleYear("FIRST");
        }
    };

    _onLaterBtnClicked(evt) {
        console.log("_onLaterBtnClicked")
        if (!this._laterBtn.hasClass("active")) {
            this._toggleYear("LATER");
        }
    };

    _onThemeSetChanged(evt) {
        if (this._map.activeThemeSet) {
            this._toggleYear("LATER");
            this._firstBtn.prop("disabled", "");
            this._laterBtn.prop("disabled", "");
        } else {
            this._firstBtn.prop("disabled", true);
            this._laterBtn.prop("disabled", true);
            this._firstBtn.removeClass("active");
            this._laterBtn.removeClass("active");
        }
    };

    _toggleYear(year) {
        switch (year) {
            case "FIRST":
                this._firstBtn.addClass("active");
                this._laterBtn.removeClass("active");
                this._toggleVisibleLayers(C.MAP_TOOLS.TOGGLE_YEARS.FIRST[this._map.activeThemeSet.id].visibleLayers);
                break;
            case "LATER":
                this._firstBtn.removeClass("active");
                this._laterBtn.addClass("active");
                this._toggleVisibleLayers(C.MAP_TOOLS.TOGGLE_YEARS.LATER[this._map.activeThemeSet.id].visibleLayers);
                break;
            default:
                throw new Error("ToggleYears._toggleYear() - year :" + year + " is invalid.");
        };
        //toggle charts de façon asynchrone
        setTimeout(this._toggleVisibleCharts.bind(this), 0);
    };

    _toggleVisibleLayers(visibleLayersIds) {
        for (var i=0; i < this._map.layers.length; i++ ) {
            if (this._map.layers[i].layerType != "TILE") {
                if (visibleLayersIds.indexOf(this._map.layers[i].id) == -1) {
                    this._map.layers[i].visible = false;
                } else {
                    this._map.layers[i].visible = true;
                }
            }
        }
    };

    _toggleVisibleCharts() {
        for (var i=0; i < this._chartViewController._chartContainers.length; i++) {
            if (this._chartViewController._chartContainers[i]._currentChart.data._interactiveLayer.visible) {
                this._chartViewController._chartContainers[i]._element.style.display = "";
            } else {
                this._chartViewController._chartContainers[i]._element.style.display = "none";
            }
        }
        this._chartViewController._refreshCharts();
    };
}
